import { useState, useEffect } from 'react';
import api from '../utils/api';

/**
 * Server-driven flag from System Settings (`ui.show_demo_data`), exposed via GET /settings/sidebar-appearance.
 */
export default function useShowDemoUi() {
  const [showDemoDataInUi, setShowDemoDataInUi] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get('/settings/sidebar-appearance', { skipErrorToast: true });
        const v = r.data?.data?.showDemoDataInUi;
        if (!cancelled) setShowDemoDataInUi(v !== false && v !== 'false');
      } catch {
        if (!cancelled) setShowDemoDataInUi(true);
      }
    };
    load();
    const refresh = () => {
      load();
    };
    window.addEventListener('erp4c-sidebar-appearance-updated', refresh);
    return () => {
      cancelled = true;
      window.removeEventListener('erp4c-sidebar-appearance-updated', refresh);
    };
  }, []);

  return showDemoDataInUi;
}
